import { Injectable } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import writeXlsxFile, { Schema } from 'write-excel-file/browser';
import { from, Observable } from 'rxjs';
import { MxTableColumn } from 'src/app/shared/domains/common/interfaces';
import { MxColumnType } from 'src/app/shared/enums';
import {
  MxDateFormatPipe,
  MxFirstLetterOperationPipe,
} from 'src/app/shared/pipes';

@Injectable({
  providedIn: 'root',
})
export class MxExportService {
  constructor(
    private i18nextPipe: I18NextPipe,
    private firstLetterOperationPipe: MxFirstLetterOperationPipe,
    private dateFormatPipe: MxDateFormatPipe
  ) {}

  excelExport(
    datasource: any[],
    columns: MxTableColumn[],
    fileName: string
  ): Observable<any[]> {
    const dsOut: any[] = [];

    datasource.forEach((val) => {
      const value = Object.assign({}, val);
      const newValue: any = {};

      Object.keys(value).forEach((key) => {
        const col = columns.find((f) => f.field === key);
        if (col) {
          this.transformData(col, value);
          newValue[
            this.i18nextPipe.transform(
              `field:${
                col.header
                  ? col.header
                  : this.firstLetterOperationPipe.transform(col.field)
              }`
            )
          ] = value[key];
        }
      });

      dsOut.push(Object.assign({}, newValue));
    });

    const headers = Object.keys(dsOut[0] ?? {});
    const schema: Schema<any> = headers.map((header) => ({
      column: header,
      type: String,
      width: Math.max(header.length + 2, 20),
      value: (row) =>
        row[header] === null || row[header] === undefined
          ? ''
          : String(row[header]),
    }));

    return from(
      writeXlsxFile(dsOut, {
        schema,
        fileName: `${fileName}_export_${new Date().getTime()}.xlsx`,
      }).then(() => {
        return dsOut;
      })
    );
  }

  private transformData(col: MxTableColumn, data: any): void {
    if (col.type === MxColumnType.Boolean) {
      data[col.field] = data[col.field]
        ? this.i18nextPipe.transform('Yes')
        : this.i18nextPipe.transform('No');
    } else if (col.type === MxColumnType.Enum) {
      data[col.field] = this.i18nextPipe.transform(
        `enum:${col.enumName}.${col.enum[data[col.field]]}`
      );
    } else if (col.type === MxColumnType.Number && col.isPercentage) {
      data[col.field] = data[col.field] * 100;

    } else if (col.type === MxColumnType.Date) {
      data[col.field] = this.dateFormatPipe.transform(
        data[col.field],
        'YYYY.MM.DD.'
      );
    } else if (col.type === MxColumnType.DateTime) {
      data[col.field] = this.dateFormatPipe.transform(
        data[col.field],
        'YYYY.MM.DD. HH:mm'
      );
    }

    if (col.prefix) {
      data[col.field] = `${col.prefix}${data[col.field]}`;
    }

    if (col.suffix) {
      data[col.field] = `${data[col.field]}${col.suffix}`;
    }
  }
}
